__turbopack_context__.v({
  "columnSkeleton": "mTTfBW_columnSkeleton",
  "dayHeader": "mTTfBW_dayHeader",
  "priceTableBody": "mTTfBW_priceTableBody",
  "priceTableColumn": "mTTfBW_priceTableColumn",
  "priceTableColumnDisabled": "mTTfBW_priceTableColumnDisabled",
  "priceTableRoot": "mTTfBW_priceTableRoot",
});
